export default [
    // === Global routes ===
    {
        path: "company",
        name: "clients",
        component: "clientsIndex",
    },
    {
        path: "telescope",
        name: "telescope",
        component: "telescopePage",
    },
    {
        path: "telescope/:uuid",
        name: "telescope.show",
        component: "telescopeShowPage",
    },
    {
        path: "prodevis-imports",
        name: "prodevis_imports",
        component: "prodevisImports",
    },
    // === Company-scoped routes ===
    // IMPORTANT: specific routes (telescope, prodevis) MUST be before the catch-all :section? route
    {
        path: "company/:id/telescope/:uuid",
        name: "company.telescope.show",
        component: "telescopeShowPage",
    },
    {
        path: "company/:id/telescope",
        name: "company.telescope",
        component: "telescopePage",
    },
    {
        path: "company/:id/prodevis",
        name: "company.prodevis",
        component: "prodevisImports",
    },
    {
        path: "company/:id/:section?",
        name: "company.show",
        component: "companyShowPage",
    },
]
